import { render, staticRenderFns } from "./Infra.vue?vue&type=template&id=84f9b7ae"
import script from "./Infra.vue?vue&type=script&lang=js"
export * from "./Infra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports